import { useState } from 'react';
import { Button } from 'antd';
import './MultiStepForm.css';
import { useLanguage } from '../../utils/LanguageContext';
import translations from '../ComponentsTranslations.lang.json';

const step = (title, component, props) => ({ title, component, props });

const MultiStepForm = ({ steps, onCompletion }) => {
  const [step, setStep] = useState(0);
  const { lang } = useLanguage(translations);

  const isLastStep = step === steps.length - 1;

  const goToNextStep = () => setStep(step + 1);
  const goToPreviousStep = () => setStep(step - 1);

  const renderedComponents = {};
  for (const [componentStep, { component, props }] of Object.entries(steps)) {
    renderedComponents[componentStep] = component({
      key: componentStep,
      onFinish: isLastStep ? onCompletion : goToNextStep,
      submitLabel: isLastStep ? lang('finish') : lang('next'),
      ...props,
    });
  }

  return (
    <div className="page-containter">
      <div className="form-input-group">
        <h1>{steps[step].title}</h1>
        {renderedComponents[step]}
        <div className="button-container">
          {step !== 0 && (
            <Button onClick={goToPreviousStep} htmlType="button">
              {lang('back')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export { step };
export default MultiStepForm;
